class productModal {
  constructor(element) {
    this.modal = element;
    this.closeBtn = element.querySelector('.js-product-modal-close');
    this.background = element.querySelector('.js-product-modal-background');
    this.content = element.querySelector('.js-product-modal-content');
    this.body = document.querySelector('body');
    this.init();
  }

  get quickAddBtns() {
    return document.querySelectorAll('.my-quick-product-add');
  }

  init = () => {
    this.addEventListeners();
  }

  addEventListeners = () => {
    this.closeBtn.addEventListener('click', this.closeModal);
    this.background.addEventListener('click', this.closeModal);
    this.quickAddBtns.forEach(element => element.onclick = (event) => {
      element.classList.add('active');
      this.activateModal(event);
      const productHandle = element.getAttribute('data-product-handle');
      this.getProductData(productHandle);
    })
  }

  getProductData = (productHandle) => {
    fetch(`/products/${productHandle}.json`)
    .then(response => response.json())
    .then(response => {
      fetch(`/products/${response.product.handle}`)
      .then(result => result.text())
      .then(result => {
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(result, 'text/html'); 
               
        // Extract reviews element
        const reviewsElement = htmlDoc.getElementById('okendo');
        const reviews = '<div id="okendo">' + reviewsElement.innerHTML + '</div>';

        // Extract shopPay element
        const shopPayElement = htmlDoc.getElementById('product-form-installment');
        const shopPay = '<form method="post" action="/cart/add" id="product-form-installment">' + shopPayElement.outerHTML + '</form>';
        
        //Extract Back In Stock element
        const backStockElement = htmlDoc.querySelector('back-in-stock');
        const backStock = '<back-in-stock>'+ backStockElement.innerHTML +'</back-in-stock>';

        // Extract Color Swatch elemnt 
        const colorElement = htmlDoc.querySelector('.product-form__input.color');
        let colorSwatch = '';
        if(colorElement){
          colorSwatch = '<div class="quickview_color_swatch">' + colorElement.outerHTML + '</form>';
        }
                
        const productPageExtractedElements = {
          reviews,
          shopPay,
          colorSwatch,
          backStock
        }
        this.populateModal(response.product, productPageExtractedElements);
        this.modal.setAttribute('data-datalayer-trigger', 'view_item');
        this.modal.setAttribute('data-view-item-handle', `${productHandle}`);
      })
    })
    .catch(error => {
      this.populateModal(response.product, '');
      console.log(error)
    })
  }

  populateModal = (productData, productPageExtractedElements) => {
    const modalTemplate = document.getElementById('product-modal-template');
    let template = modalTemplate.innerHTML;
    let images = '';
    let title = '';
    let subtitle = '';
    let description = '';
    let limiterAlertCopy = 'This item cannot be combined with custom products. <br />Custom products will be removed from the cart.'
    const { shopPay, reviews, colorSwatch, backStock } = productPageExtractedElements;

    if (productData.title.includes('-')) {
      title = productData.title.split('-')[1];
      subtitle = productData.title.split('-')[0];
    } else {
      title = productData.title;
      subtitle = productData.product_type;
    }

    const bodyHtml = productData.body_html.trim();
    // remove html tags
    const plainText = bodyHtml.replace(/<\/?[^>]+(>|$)/g, "");
    const firstPeriodIndex = plainText.indexOf('.');
    if (firstPeriodIndex !== -1) {
      description = plainText.substring(0, firstPeriodIndex + 1);
    } else {
      description = plainText;
    }

    if (productData.product_type.includes('Custom Order')) {
      limiterAlertCopy = 'Custom products cannot be combined with other items. <br />Other items will be removed from the cart.'
    }

    productData.images.forEach(image => {
      images = images + `<div class="product-modal-content__image" data-image-id="${image.id}"><img src="${image.src}" alt="${productData.title}" style="opacity:0;" /></div>`;
    });

    let options = '';

    if(productData.options.length == 1){
      productData.variants.forEach((variant, index) => {
        if (index == 0) {
          options = options + `<button class="product-modal-content__options-item is-active js-product-modal-content-variant" data-product-price="${variant.price}" data-product-compare-price="${variant.compare_at_price}" data-product-id="${variant.id}" data-product-inventory="${variant.inventory_quantity}" data-product-variant-image-id="${variant.image_id}">${variant.title}</button>`;
        } else {
          options = options + `<button class="product-modal-content__options-item js-product-modal-content-variant" data-product-price="${variant.price}" data-product-compare-price="${variant.compare_at_price}" data-product-id="${variant.id}" data-product-inventory="${variant.inventory_quantity}" data-product-variant-image-id="${variant.image_id}">${variant.title}</button>`;
        }
      })
      template = template.replace(/productModalOptionTitle/g, productData.options[0].name);
    } else {
      productData.variants.forEach((variant, index) => {
        let variantTitle = variant.title;
        let variantTitleSplit = variantTitle.split('/');
        let variantSizeTitle = variantTitleSplit.length > 0 ? variantTitleSplit[variantTitleSplit.length - 1] : '';
        if (index == 0) {
          options = options + `<button class="product-modal-content__options-item is-active js-product-modal-content-variant" data-product-price="${variant.price}" data-product-compare-price="${variant.compare_at_price}" data-product-id="${variant.id}" data-product-inventory="${variant.inventory_quantity}">${variantSizeTitle}</button>`;
        } else {
          options = options + `<button class="product-modal-content__options-item js-product-modal-content-variant" data-product-price="${variant.price}" data-product-compare-price="${variant.compare_at_price}" data-product-id="${variant.id}" data-product-inventory="${variant.inventory_quantity}">${variantSizeTitle}</button>`;
        }
      })
      template = template.replace(/productModalOptionTitle/g, productData.options[1].name);
    }
    

    
    template = template.replace(/productModalOptions/g, options);
    template = template.replace(/productModalShopPay/g, shopPay);
    template = template.replace(/productModalReviews/g, reviews);
    template = template.replace(/productModalHref/g, '/products/' + productData.handle);
    template = template.replace(/productModalSubtitle/g, subtitle);
    template = template.replace(/productModalProductId/g, productData.variants[0].id);
    template = template.replace(/productModalTitle/g, title);
    template = template.replace(/productModalImages/g, images);
    template = template.replace(/productModalDesciption/g, description);
    template = template.replace(/productModalColorSwatch/g, colorSwatch);
    template = template.replace(/productModalLimiterAlertCopy/g, limiterAlertCopy);
    template = template.replace(/productModalBackInStick/g, backStock);

    //show sale price is applicable
    let templatePriceStr = '$' + productData.variants[0].price;
    if(!!productData.variants[0].compare_at_price){
      const cprice = parseFloat(productData.variants[0].compare_at_price);
      const price = parseFloat(productData.variants[0].price);
      if(cprice > price){
        templatePriceStr = `<s>$${productData.variants[0].compare_at_price.replace(".00","")}</s><span class="sale">$${productData.variants[0].price.replace(".00","")}</span>`;
      }
    }
    if (productData.variants[0].inventory_quantity > 0) {
      template = template.replace(/productModalPrice/g, templatePriceStr);
    } else {
      template = template.replace(/productModalPrice/g, 'Sold Out');
    }



    this.content.innerHTML = template;
    
    if (productData.variants[0].inventory_quantity > 0) {
      this.content.querySelector('.product-modal-content__actions').classList.remove('hidden');
    }else{
      this.content.querySelector('.product-modal-content__actions').classList.add('hidden');
    }

    const elementSliderInit = new Flickity(this.content.querySelector('.js-product-modal-content-images'), {
      imagesLoaded: true,
      contain: true,
      draggable: true,
      pageDots: false
    });

    let intervals = 0;

    const resizeInterval = setInterval(() => {
      if (intervals < 7) {
        if(intervals == 0) {
          this.modal.classList.remove('is-loading');
        }
        elementSliderInit.resize();
        if(intervals == 0) {
           this.content.querySelectorAll('.product-modal-content__image img').forEach(image=> {
            image.style.opacity = 1;
          });
        }
        intervals = intervals + 1;
      } else {
        clearInterval(resizeInterval);
      }
    }, 250);

    this.content.querySelector('.js-product-modal-content-submit').addEventListener('click', this.addProductToCart);

    this.content.querySelectorAll('.js-product-modal-content-variant').forEach(element => element.addEventListener('click', this.variantSwitchHandle));

    this.content.querySelectorAll('.quickview_color_swatch .js-color-change').forEach(element => element.addEventListener('click', function(e){
      e.preventDefault();
      let productHandle = element.getAttribute('data-product-handle');
      document.querySelector('.my-quick-product-add.active').setAttribute('data-product-handle', productHandle);
      setTimeout(() => {
        document.querySelector('.my-quick-product-add[data-product-handle="'+productHandle+'"]').click();
      }, 200);
    }));

    this.content.querySelector('.back_in_stock .notify__form form').addEventListener('submit', this.onSubmitHandler);
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    const formElement = evt.target;
    const email = formElement.querySelector('[name="email"]').value;
    const variant = formElement.querySelector('[name="variant"]').value;
    
    fetch(this.action, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        revision: '2024-06-15',
        'content-type': 'application/json'
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variant}`
              }
            }
          }
        }
      }),
    })
    .then((response) => {
      if(response.status === 202) {
        document.querySelector('.back_in_stock .notify').classList.add('notify--success');
      }
    })
    .catch(error => {
        console.error('Fetch error:', error);
    });
  }

  variantSwitchHandle = (event) => {
    const productPrice = event.target.getAttribute('data-product-price');
    const productComparePrice = event.target.getAttribute('data-product-compare-price');
    const productId = event.target.getAttribute('data-product-id');
    const productInventory = event.target.getAttribute('data-product-inventory');
    const priceContainer = document.querySelector('.product-modal-content__price');
    const productImageId = event.target.getAttribute('data-product-variant-image-id');
    let parsedValue = JSON.parse(productImageId);
    // If you want to convert it back to a string
    let stringValue = JSON.stringify(parsedValue);

    if(productInventory == 0){
      document.querySelector('.product-modal-content__actions').classList.add('hidden');
      document.querySelector('.back_in_stock .notify.js-notify').classList.remove('hidden');
    } else {
      document.querySelector('.product-modal-content__actions').classList.remove('hidden');
      document.querySelector('.back_in_stock .notify.js-notify').classList.add('hidden');
    }
    document.querySelector('.back_in_stock .notify.js-notify [name="variant"]').value = productId;

    // Update Price when variant is changed
    priceContainer.innerText = '$' + productPrice;
    if(productComparePrice) {
      const variantComparePrice = parseFloat(productComparePrice);
      const variantPrice = parseFloat(productPrice);
      if(variantComparePrice > variantPrice) {
        priceContainer.innerHTML = `<s>$${variantComparePrice}</s><span class="sale">$${variantPrice}</span>`;
      }
    }

    event.target
      .closest('.js-product-modal-content-variants')
      .querySelector('.is-active')
      .classList.remove('is-active');

    event.target
      .classList.add('is-active');

    event.target
      .closest('.js-product-modal-content')
      .querySelectorAll('.product-modal-content__btn')
      .forEach((el) => el.setAttribute('data-product-id', productId));
    
      const imageSlider = new Flickity(this.content.querySelector('.js-product-modal-content-images'));

      const productImage = document.querySelectorAll('.product-modal-content .product-modal-content__image');
      productImage.forEach((slide, index) => {
        if (slide.getAttribute('data-image-id') == productImageId) {
          imageSlider.select(index);
        }
      });
    
  }

  addProductToCart = (event) => {
    event.preventDefault();

    const productId = event.target.getAttribute('data-product-id');

    const items_added = [{
        'id': productId,
        'quantity': 1
      }];
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items_added })
    })
      .then(response => {
        return response.json();
      })
      .then(result => {
        if (true) {
          this.modal.querySelector('.js-product-modal-content-error').innerHTML = result.description;
        }
        if (!result.status) {
          this.modal.querySelector('.js-product-modal-content-error').innerHTML = '';
          this.modal.classList.add('is-loading');
          refreshCart(); //refresh cart
          $('.product-modal__close').click(); //close modal
          document.dispatchEvent(new CustomEvent("cart:item:added", { detail:
            {
              "response": result,
              "items_added": items_added
            }
          }));
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  closeModal = () => {
    this.modal.classList.remove('is-active');
    this.body.style.overflow = '';
    this.content.innerHTML = '';
    let activeQuickModal = document.querySelectorAll('.my-quick-product-add');
    activeQuickModal.forEach(function(element) {
      element.classList.remove('active');
      let oldProductHandle = element.getAttribute('data-product-updated-handle');
      element.setAttribute('data-product-handle', oldProductHandle);
    });

  }

  activateModal = (event) => {
    event.preventDefault;
    this.modal.classList.add('is-active');
    this.body.style.overflow = 'hidden';
  }
}

const productModalEl = document.querySelector('.js-product-modal');
window.productModal = new productModal(productModalEl);

if (!customElements.get('modal-limiter-alert')) {
  class modalLimiterAlert extends HTMLElement {
    constructor() {
      super();
      this.add = this.querySelector('.product-modal-content__btn');
      this.cancel = this.querySelector('.action__cancel');
      this.proceed = this.querySelector('.action__continue');
      this.submitBtn = this.closest('.product-modal-content__actions').querySelector('button.js-product-modal-content-submit');
      this.dismissed = false;
      this.continued = false;

      // if(this.form.querySelector('[name="product_type"]').value === 'Custom Order') {
      //   this.isCustom = true;
      // } else {
      //   this.isCustom = false;
      // }

      // events
      this.cancel.addEventListener('click', this.closeModal.bind(this));
      this.add.addEventListener('click', this.checkProducts.bind(this));
      this.proceed.addEventListener('click', this.continue.bind(this));
    }

    closeModal() {
      this.removeAttribute('open');
      this.dismissed = true;
    }

    continue() {
      let _that = this;
      let submitBtn = this.submitBtn;
      fetch(`/cart/clear.js`)
      .then((response) => response.json())
      .then((response) => {
        document.querySelector('.cart-count-bubble span').innerText = '0';
        _that.removeAttribute('open');
        _that.continued = true;
        _that.style.display = 'none';
        submitBtn.classList.remove('hide-this');
        submitBtn.click();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {});
    }

    checkProducts() {
      let _that = this;
      let submitBtn = this.submitBtn;
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if(!this.continued) {
        fetch(`${routes.cart_url}.js`, config)
        .then((response) => response.json())
        .then((response) => {
          if(response.items.length > 0) {
            let customInCart = false;
            let normalProductsInCart = false;
            response.items.forEach(item => {
              if(item.product_type == "Custom Order"){
                customInCart = true;
              } else {
                normalProductsInCart = true;
              }
            });

            if(this.isCustom && normalProductsInCart) {
              _that.setAttribute('open', '');
            } else if (!this.isCustom && customInCart){
              _that.setAttribute('open', '');
            } else {
              _that.style.display = 'none';
              submitBtn.classList.remove('hide-this');
              submitBtn.click();
            }
          } else {
            _that.style.display = 'none';
            submitBtn.classList.remove('hide-this');
            submitBtn.click();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
        });
      } else {
        _that.style.display = 'none';
        submitBtn.classList.remove('hide-this');
        this.submitBtn.click();
      }
    }
  }

  customElements.define('modal-limiter-alert', modalLimiterAlert);
}